import { Check, Translate } from '@mui/icons-material'
import { IconButton, Menu, MenuItem, Stack, Typography } from '@mui/material'
import { useState } from 'react'

import { Language, LanguageManager, tolgee } from '@/i18n/tolgee'
import useT from '@/i18n/useT'

interface LanguageSelectorProps {
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse'
  showLabel?: boolean
}

function LanguageSelector({
  direction = 'row-reverse',
  showLabel = false,
}: LanguageSelectorProps) {
  const { t } = useT()
  const [openLanguageMenu, setOpenLanguageMenu] = useState(false)
  const [languageMenuAnchorEl, setLanguageMenuAnchorEl] =
    useState<null | HTMLElement>(null)

  const handleLanguageMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setLanguageMenuAnchorEl(event.currentTarget)
    setOpenLanguageMenu(true)
  }

  const handleLanguageMenuClose = () => {
    setOpenLanguageMenu(false)
    setLanguageMenuAnchorEl(null)
  }

  const handleChangeLanguage = (language: Language) => {
    LanguageManager.setCurrentLanguage(language)
    handleLanguageMenuClose()
  }

  return (
    <>
      <Stack direction={direction} alignItems="center" spacing={1}>
        <IconButton onClick={handleLanguageMenuClick}>
          <Translate />
        </IconButton>
        {showLabel && <Typography>{t('common.language')}</Typography>}
      </Stack>
      <Menu
        open={openLanguageMenu}
        anchorEl={languageMenuAnchorEl}
        onClose={handleLanguageMenuClose}
      >
        <MenuItem onClick={() => handleChangeLanguage('en')}>
          <Typography variant="body2">{t('common.english')}</Typography>
          {tolgee.getLanguage() === 'en' && <Check sx={{ marginLeft: 2 }} />}
        </MenuItem>
        <MenuItem onClick={() => handleChangeLanguage('es')}>
          <Typography variant="body2">{t('common.spanish')}</Typography>
          {tolgee.getLanguage() === 'es' && <Check sx={{ marginLeft: 2 }} />}
        </MenuItem>
      </Menu>
    </>
  )
}

export default LanguageSelector
